import { Props } from '@models/types/genieask.type';
import WorksheetMinichat from '@pages/genieask/WorksheetMinichatPage';
import React, { Suspense, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';
const WorksheetQuestionWidget = React.lazy(
  () => import('geniesmart/WorksheetQuestionWidget'),
);

const WorksheetQuestionPage = () => {
  const { worksheetId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (worksheetId === undefined) {
      navigate('/mathematics/worksheets');
    }
  }, [navigate, worksheetId]);

  const onHide = () => {
    navigate('/mathematics/worksheets');
  };

  const [worksheetMinichatProps, setWorksheetMinichatProps] =
    React.useState<Props>();
  const handleTeacherChatClick = (param: Props) => {
    setWorksheetMinichatProps(param);
  };
  return (
    <>
      <Helmet>
        <title>Geniebook - Worksheet Question</title>
        <meta name="description" content="Worksheet Question" />
      </Helmet>
      <Suspense>
        <WorksheetQuestionWidget
          key={worksheetId}
          worksheet_id={parseInt(worksheetId ?? '0')}
          onHide={onHide}
          teacherChatComponent={
            worksheetMinichatProps && (
              <WorksheetMinichat {...worksheetMinichatProps} />
            )
          }
          handleTeacherChatClick={handleTeacherChatClick}
        />
      </Suspense>
    </>
  );
};

export default WorksheetQuestionPage;
